import React from "react";
import { HiOutlinePhotograph } from "react-icons/hi";

function Avatar({ image }) {
  return (
    <>
      {image ? (
        <div className="flex h-10 w-10">
          <div
            style={{ backgroundImage: `url(${image})` }}
            className="w-10 h-10 relative rounded-full bg-center bg-cover border"
          ></div>
        </div>
      ) : (
        <div
          className={`flex items-center justify-center h-10 w-10 p-2 ${!image && "bg-gray-100 rounded-full"}`}
        >
          <HiOutlinePhotograph className="w-10 h-10 text-gray-700" />
        </div>
      )}
    </>
  );
}

export default Avatar;
